import React from "react"
import { useTranslation } from "react-i18next"

const ContactInfo = () => {
  const { t } = useTranslation()

  return (
    <section className="mx-auto max-w-7xl p-8 space-y-4">
      <h2 className="text-xl md:text-2xl font-semibold">
        {t("about.contact.title")}
      </h2>
      <div className="bg-blue-200 shadow-lg overflow-hidden sm:rounded-lg p-6 max-w-sm">
        <h3 className="text-lg leading-6 font-medium text-gray-500 font-bold">
          Email
        </h3>
        <div className="mt-2 max-w-xl text-sm text-gray-900">
          <p>{t("about.contact.email-address")}</p>
        </div>
      </div>
    </section>
  )
}

export default ContactInfo
